import React, { Component } from 'react';
import QuestionnairePanel from 'components/QuestionnairePanel';
import get from 'utils/get';
import arrayify from 'utils/arrayify';
import { withRouter } from 'react-router-dom';
import SegmentWrapper from 'lib/segment';

export default withRouter(class QuestionnaireParent extends Component {
  constructor(props) {
    super(...arguments);
    let validity = (this.validityForProps(props) || []);

    let relevantQs = this.relevantQs(validity);
    let relevantQsValidity = relevantQs.map(q => validity.find(v => v.id === q.id));
    let latestInvalidQuestionSet = relevantQsValidity.find(v => !v.valid);

    let stage = latestInvalidQuestionSet ? latestInvalidQuestionSet.id : relevantQsValidity[relevantQsValidity.length - 1].id;
    this.state = { stage, valid: validity.find(v => v.id === stage).valid, validity };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ validity: this.validityForProps(nextProps) });
  }

  /* Validitiy Biz */
  validityForProps(props = this.props) {
    let allQs = get(props, 'questions', {});
    let allRs = get(props, 'results', {});
    return Object.keys(allQs).map(key => {
      let coreQ = allQs[key];
      let valid, responses;
      switch (coreQ.type) {
        case 'all':
          responses = Object.keys(coreQ.items).map(key => {
            return [key, (allRs[key] || "")];
          });
          valid = responses.every(resp => resp[1].length > 0)
          return { id: key, valid, responses }
        case 'some':
        case 'discrete':
          responses = Object.keys(coreQ.items).map(key => {
            return [key, allRs[key]];
          });
          valid = !!responses.find(resp => !!resp[1]);
          return { id: key, valid, responses }
      }
    });
  }

  validityFor = q => this.state.validity.find(item => item.id === q.id).valid

  /* Warning, future developer:
   * I'm sorry. I'm not sure a better way to do this,
   * but basically there's a bunch of arbitary rules
   * as to which questions a user should be served based
   * on previous answers.  Q2 & Q5 (regular) are the two
   * that create forks.  That should be clear here, but I
   * know this code is gnarly in generaly.  I love you
   */
  relevantQs = (v = this.state.validity) => {
    /* q2 is basically a huge swith */
    let q2 = v.find(q => q.id === "2");

    /* When not valid, we can't know the final Q path */
    let relevant = arrayify({ "1": this.props.questions["1"], "2": this.props.questions["2"] });
    if (!q2.valid) return relevant;

    let q2Res = q2.responses.find(res => res[1])[0];

    /* When a user selects 2b or 2d, we treat the remaining set differently */
    if (["2b", "2d"].includes(q2Res)) {
      relevant = Object.keys(this.props.questions).reduce((a, key) => {
        if (key.endsWith(q2Res)) {
          let newObj = Object.assign({}, this.props.questions[key]);
          newObj.id = key;
          return a.concat(newObj);
        }
        return a;
      }, relevant);
    } else {

      /* q5 has subsets of questions */
      let q5 = v.find(q => q.id === "5");
      let q5Res;
      if (q5.valid) {
        q5Res = q5.responses.find(res => res[1])[0];
      }

      relevant = Object.keys(this.props.questions).reduce((a, key) => {
        if ((key.split("-").length - 1) === 0 && key !== "1" && key !== "2") {
          let newObj = Object.assign({}, this.props.questions[key]);
          newObj.id = key;
          return a.concat(newObj);
        }
        /* The Regular Question 5 creates a fork */
        if (!!q5Res) {
          if (key === `6-${q5Res}`) {
            let newObj = Object.assign({}, this.props.questions[key]);
            newObj.id = key;
            a.splice(
              a.indexOf(a.find(i =>i.id === "5")) + 1,
              0,
              newObj
            );
          }
        } else {
          /* Q5 isn't yet answered, so use 6-5a for now */
          if (key === `6-5a`) {
            let newObj = Object.assign({}, this.props.questions[key]);
            newObj.id = key;
            a.splice(
              a.indexOf(a.find(i =>i.id === "5")) + 1,
              0,
              newObj
            );
          }
        }
        return a;
      }, relevant);
    }
    return relevant;
  }

  /* Next Utils */
  nextQFor = q => {
    let relevantQsForValidity = this.relevantQs().map(q => q.id);
    return relevantQsForValidity[relevantQsForValidity.indexOf(q.id) + 1]
  }

  canGoForward = q => {
    let isValid = this.validityFor(q);
    if (!isValid) return false;
    return true;
  }

  next = q => {
    if (!this.canGoForward(q)) return;
    let nextPanel = this.nextQFor(q);
    if (nextPanel) {
      SegmentWrapper.didCompletePanel(this.state.validity.find(item => item.id === q.id), q);
      this.setState({ stage: nextPanel, valid: this.validityFor(q) });
    } else {
      SegmentWrapper.didCompletePanel(this.state.validity.find(item => item.id === q.id), q);
      SegmentWrapper.didSubmitSurvey();
      this.props.history.push('/qualify');
    }
  }

  /* Back Utils */
  prevQFor = q => {
    let relevantQsForValidity = this.relevantQs().map(q => q.id);
    return relevantQsForValidity[relevantQsForValidity.indexOf(q.id) - 1]
  }

  canGoBack = q => !!this.prevQFor(q)

  back = q => {
    if (!this.canGoBack(q)) return;
    let prevPanel = this.prevQFor(q);
    if (prevPanel) this.setState({ stage: prevPanel, valid: this.validityFor(q) });
  }

  /* Render Biz */
  renderPanels = () => {
    let relevantQs = this.relevantQs();
    return relevantQs.map((q, i) => {
      return (
        <QuestionnairePanel
          valid={this.validityFor(q)}
          next={() => this.next(q)}
          back={() => this.back(q)}
          canNext={this.canGoForward(q)}
          canBack={this.canGoBack(q)}
          current={this.state.stage === q.id}
          key={q.id}
          q={q}
          index={i + 1}
          didSelectOption={(item, q) => this.props.setResult(item, q)}
          r={get(this, 'props.results')}
          totalQs={relevantQs.length}
        />
      );
    });
  }


  render() {
    return <div>{this.renderPanels()}</div>
  }
});



// WEBPACK FOOTER //
// ./src/components/QuestionnaireParent.js